export default __webpack_public_path__ + "static/media/pizza.ddec0b69.svg";